import { Box, Stack } from "@mui/material";

import styled from "styled-components";

export const PageWrapper = styled(Box)`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
`;

export const HeaderRow = styled(Stack)`
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    background: #fff;
    flex-shrink: 0;

    @media (max-width: 768px) {
        padding: 12px 16px;
        flex-direction: column !important;
        gap: 12px;
    }
`;

export const SourceDestinationRow = styled(Stack)`
    align-items: center;
    gap: 8px;

    @media (max-width: 768px) {
        flex-wrap: wrap;
    }
`;

export const ChipLabel = styled(Box)`
    font-size: 14px;
    font-weight: 500;
`;

export const DebugBadge = styled(Box)`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 6px 12px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    background: rgba(46, 125, 50, 0.08);
    color: #2e7d32;
`;

export const DebugBadgeDot = styled.span<{ $pulse?: boolean }>`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #2e7d32;
    ${({ $pulse }) =>
        $pulse
            ? `
    animation: pulse 1.5s ease-in-out infinite;
    @keyframes pulse {
        0%, 100% { opacity: 1; }
        50% { opacity: 0.5; }
    }
    `
            : ""}
`;

export const DebugToggleContainer = styled(Box)`
    display: inline-flex;
    align-items: center;
    gap: 12px;
    padding: 8px 16px;
    border-radius: 8px;
    background: #fff;

    @media (max-width: 768px) {
        width: 100%;
        justify-content: space-between;
    }
`;

export const DebugToggleLabel = styled(Box)`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const DebugToggleTitle = styled(Box)`
    font-size: 14px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.87);
`;

export const DebugToggleExpiry = styled(Box)`
    font-size: 11px;
    color: rgba(0, 0, 0, 0.6);
`;

export const MainContent = styled(Box)`
    display: flex;
    flex: 1;
    min-height: 0;
    overflow: hidden;
    height: calc(100vh - 140px);

    @media (max-width: 768px) {
        flex-direction: column;
        height: auto;
        min-height: calc(100vh - 200px);
    }
`;

export const Sidebar = styled(Box)`
    width: 320px;
    min-width: 320px;
    max-height: 100%;
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    background: #fff;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    @media (max-width: 768px) {
        width: 100%;
        min-width: 100%;
        border-right: none;
        border-bottom: 1px solid rgba(0, 0, 0, 0.12);
        max-height: 50vh;
    }
`;

export const SidebarHeader = styled(Box)`
    padding: 16px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);

    @media (max-width: 768px) {
        padding: 12px;
    }
`;

export const SidebarTitle = styled(Box)`
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: rgba(0, 0, 0, 0.6);
    margin-bottom: 12px;
`;

export const SidebarSearch = styled(Box)`
    margin-bottom: 12px;
`;

export const LogList = styled(Box)`
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 12px;
    padding-bottom: 12px;
    min-height: 0;
    max-height: calc(100vh - 300px);

    @media (max-width: 768px) {
        max-height: calc(50vh - 180px);
        padding: 8px;
    }
`;

export const SidebarFooter = styled(Box)`
    padding: 12px 16px;
    border-top: 1px solid rgba(0, 0, 0, 0.12);
    background: #fff;
    flex-shrink: 0;

    @media (max-width: 768px) {
        padding: 10px 12px;
    }
`;

export const LogCard = styled(Box)<{ $selected?: boolean }>`
    padding: 12px;
    border-radius: 12px;
    border: 1px solid
        ${({ $selected }) =>
            $selected ? "rgba(237, 108, 2, 0.5)" : "transparent"};
    background: ${({ $selected }) =>
        $selected ? "rgba(237, 108, 2, 0.06)" : "transparent"};
    margin-bottom: 8px;
    cursor: pointer;
    transition:
        background 0.2s,
        border-color 0.2s;

    @media (max-width: 768px) {
        padding: 10px;
        border-radius: 8px;
    }

    &:hover {
        background: ${({ $selected }) =>
            $selected ? "rgba(237, 108, 2, 0.08)" : "rgba(0, 0, 0, 0.04)"};
    }
`;

export const LogCardSkeleton = styled(Box)`
    padding: 12px;
    border-radius: 12px;
    border: 1px solid transparent;
    margin-bottom: 8px;
    pointer-events: none;

    @media (max-width: 768px) {
        padding: 10px;
        border-radius: 8px;
    }
`;

export const LogCardTop = styled(Stack)`
    margin-bottom: 4px;
`;

export const LogCardMeta = styled(Stack)`
    font-size: 12px;
    color: rgba(0, 0, 0, 0.6);

    @media (max-width: 768px) {
        font-size: 11px;
    }
`;

export const DetailSection = styled(Box)`
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
    overflow: hidden;
    height: 100%;
`;

export const DetailHeader = styled(Box)`
    padding: 24px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    background: #fff;
    flex-shrink: 0;

    @media (max-width: 768px) {
        padding: 16px;
    }
`;

export const DetailTitle = styled(Box)`
    font-size: 24px;
    font-weight: 700;
    letter-spacing: -0.02em;
    margin-bottom: 8px;

    @media (max-width: 768px) {
        font-size: 18px;
    }
`;

export const DetailMeta = styled(Stack)`
    font-size: 14px;
    color: rgba(0, 0, 0, 0.6);
`;

export const DetailActions = styled(Stack)`
    gap: 8px;
`;

export const TimelineSection = styled(Box)`
    padding: 24px 24px 0;
    flex-shrink: 0;

    @media (max-width: 768px) {
        padding: 16px 16px 0;
    }
`;

export const TimelineTitle = styled(Box)`
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: rgba(0, 0, 0, 0.6);
    margin-bottom: 16px;
`;

export const TimelineTrack = styled(Box)`
    height: 4px;
    background: rgba(0, 0, 0, 0.08);
    border-radius: 4px;
    margin-bottom: 24px;
    position: relative;
`;

export const TimelineSteps = styled(Stack)`
    position: relative;
    margin-top: -28px;
`;

export const TimelineStep = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
`;

export const PanelsRow = styled(Stack)`
    flex: 1;
    padding: 24px;
    gap: 24px;
    min-height: 0;
    overflow: auto;
    display: flex;
    align-items: stretch;
    height: 100%;

    @media (max-width: 768px) {
        flex-direction: column !important;
        padding: 16px;
        gap: 16px;
    }
`;

export const JsonPanel = styled(Box)`
    flex: 1;
    min-width: 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
    align-self: stretch;

    @media (max-width: 768px) {
        min-height: 300px;
        height: auto;
    }
`;

export const JsonPanelHeader = styled(Stack)`
    margin-bottom: 12px;
`;

export const JsonPanelTitle = styled(Box)`
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: rgba(0, 0, 0, 0.7);
`;

export const JsonPanelContent = styled(Box)`
    flex: 1;
    min-height: 280px;
    min-width: 0;
    padding: 16px;
    border-radius: 12px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    background: #f8f9fa;
    overflow: auto;
    font-family: "Fira Code", "Monaco", "Courier New", monospace;
    font-size: 13px;
    line-height: 1.6;
    color: #24292e;

    @media (max-width: 768px) {
        font-size: 11px;
        padding: 12px;
        min-height: 200px;
    }

    .json-key {
        color: #d73a49;
        font-weight: 500;
    }

    .json-string {
        color: #d73a49;
    }

    .json-number {
        color: #005cc5;
    }

    .json-boolean {
        color: #005cc5;
    }

    .json-null {
        color: #6f42c1;
    }

    .json-bracket {
        color: #24292e;
    }

    .json-comment {
        color: #6a737d;
        font-style: italic;
    }
`;

export const JsonPre = styled.pre`
    margin: 0;
    white-space: pre-wrap;
    word-break: break-word;
`;

/**
 * The "Show Response" tooltip reuses the JSON panel look, but a tooltip has to
 * stay inside the viewport: the card caps its width and the body scrolls
 * instead of growing. The tooltip is interactive, so the JSON stays selectable.
 */
export const ResponseTooltipCard = styled(Box)`
    max-width: min(560px, 90vw);
    padding: 16px;
    border-radius: 12px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    background: #f8f9fa;
    font-family: "Fira Code", "Monaco", "Courier New", monospace;
    font-size: 13px;
    line-height: 1.6;
    color: #24292e;
    cursor: auto;

    @media (max-width: 768px) {
        font-size: 11px;
        padding: 12px;
    }
`;

export const ResponseTooltipScroll = styled(Box)`
    max-height: 320px;
    overflow: auto;
    user-select: text;

    @media (max-width: 768px) {
        max-height: 45vh;
    }
`;

export const CopyButton = styled(Box)`
    font-size: 12px;
    font-weight: 600;
    color: #ed6c02;
    cursor: pointer;
    user-select: none;

    &:hover {
        text-decoration: underline;
    }
`;

export const EmptyState = styled(Box)`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 48px 32px;
    text-align: center;
`;

export const EmptyStateTitle = styled(Box)`
    font-size: 15px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.6);
    margin-bottom: 6px;
`;

export const EmptyStateDescription = styled(Box)`
    font-size: 13px;
    color: rgba(0, 0, 0, 0.38);
    line-height: 1.6;
    max-width: 260px;
`;

export const ArrowDivider = styled(Box)`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.12);
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    align-self: center;
    color: rgba(0, 0, 0, 0.5);

    @media (max-width: 768px) {
        transform: rotate(90deg);
        margin: 8px auto;
    }
`;

const styledExports = {
    PageWrapper,
    HeaderRow,
    SourceDestinationRow,
    ChipLabel,
    DebugBadge,
    DebugBadgeDot,
    DebugToggleContainer,
    DebugToggleLabel,
    DebugToggleTitle,
    DebugToggleExpiry,
    MainContent,
    Sidebar,
    SidebarHeader,
    SidebarTitle,
    SidebarSearch,
    LogList,
    SidebarFooter,
    LogCard,
    LogCardSkeleton,
    LogCardTop,
    LogCardMeta,
    DetailSection,
    DetailHeader,
    DetailTitle,
    DetailMeta,
    DetailActions,
    TimelineSection,
    TimelineTitle,
    TimelineTrack,
    TimelineSteps,
    TimelineStep,
    PanelsRow,
    JsonPanel,
    JsonPanelHeader,
    JsonPanelTitle,
    JsonPanelContent,
    JsonPre,
    CopyButton,
    EmptyState,
    EmptyStateTitle,
    EmptyStateDescription,
    ArrowDivider,
};

export default styledExports;
